import * as React from 'react';
import OlMap from 'ol/Map';
import OlControlCtrl from 'ol/control/Control';
import EventType from 'ol/events/EventType';
import 'antd/dist/antd.min.css';
import 'ol/ol.css';
// import Icon from '@ant-design/icons';
import ReactDOM from 'react-dom';

interface IProps {
    map: OlMap; // Mapa al que fa referència
    tooltip?: string; // text que sortirà al tooltip
    onClick?: () => void; // Handle de l'acció
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    icon?: any; // Icona de Antd
    image?: string; // Imatge (si no es fa servir la propietat icon)
    hidden?: boolean; // Diu si està amagat
    className?: string; // ClassName que s'afegeix als className del control i que normalemnt s'utilitza per definir la posició del control
}

export class MyCustomControl extends React.Component<IProps, object> {
    constructor(props: IProps) {
        super(props);
        this._ref = React.createRef();
    }

    private _ref: React.LegacyRef<HTMLDivElement>;

    private myDiv: HTMLDivElement;

    private myButton: HTMLButtonElement;

    private myCtrl: OlControlCtrl;

    createControl() {
        this.myCtrl = new OlControlCtrl({
            element: this.myDiv
        });
        this.props.map.addControl(this.myCtrl);
    }

    handleClick_(event) {
        event.preventDefault();
        if (this.props.onClick)
            this.props.onClick();
    }

    componentDidMount() {
        this.myDiv = document.createElement('div');
        this.createControl();
        this.myButton = document.createElement('button');
        this.myButton.setAttribute('type', 'button');
        this.myButton.title = this.props.tooltip;
        const div = document.createElement('div');
        if (this.props.icon) {
            ReactDOM.render(
                React.createElement(
                    this.props.icon, {
                        style: { fontSize: '15px' }
                    }
                ),
                div
            );
            // ReactDOM.render(
            //     (<Icon type={this.props.icon} style={{fontSize: '16px'}}/>),
            //     div
            // );
        } else if (this.props.image) {
            ReactDOM.render(
                (<img src={this.props.image} alt="" width="15px" height="15px"/>),
                div
            );
        }
        this.myButton.appendChild(div);
        this.myButton.addEventListener(EventType.CLICK, this.handleClick_.bind(this), false);
        this.myDiv.className = 'ol-unselectable ol-control' + (this.props.hidden ? ' ol-hidden': '') + (this.props.className ? ' ' + this.props.className : '');
        this.myDiv.appendChild(this.myButton);
    }

    componentWillUnmount() {
        this.myButton.removeEventListener(EventType.CLICK, this.handleClick_.bind(this));
        this.props.map.removeControl(this.myCtrl);
    }

    render() {
        return (
            <div ref={this._ref} />
        );
    }
}
export default MyCustomControl;